// import React, { useEffect, useState, useContext } from "react";
import React from "react";
// import { AuthContext } from "../../shared/context/auth-context";
// import { Link } from "react-router-dom";
import Card from "../../shared/components/UIElements/Card";

import TradeItem from "./TradeItem";
import "./TradeList.css";

const TradeSummary = ({ data, stop_loss }) => {
  if (!data || !data.trades_summary) {
    return null;
  }
  const trades_summary = data.trades_summary;
  return (
    <React.Fragment>
      <Card className="trade-list-header">
        <table>
          <tbody>
            <tr>
              <th>Trades [-]</th>
              <th>Hold Duration [d]</th>
              <th>MDD [%]</th>
              <th>Ø PROFIT [%]</th>
              <th>Stop/Loss [%]</th>
            </tr>
          </tbody>
        </table>
      </Card>
      <Card className="instrument-item">
        <table>
          <tbody>
            <tr>
              <td>{trades_summary.NUMBER_OF_TRADES}</td>
              <td>{trades_summary.HOLD_PER_AVG.toFixed(0)}</td>
              <td>{trades_summary.MAX_MDD.toFixed(2)}%</td>
              <td>{trades_summary.PNL_PER_AVG.toFixed(2)}%</td>
              <td>{stop_loss}</td>
            </tr>
          </tbody>
        </table>
      </Card>
    </React.Fragment>
  );
};

export default TradeSummary;
